import { render, staticRenderFns } from "./DeleteAccountView.vue?vue&type=template&id=48e9de0a&"
import script from "./DeleteAccountView.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountView.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VExpandTransition,VRadio,VRadioGroup,VTextarea})
